/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_CtaInputs */

const en_visa_e2_cta = /** @type {(inputs: Visa_E2_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore your E visa options`)
};

const pt_visa_e2_cta = /** @type {(inputs: Visa_E2_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore suas opções de visto E`)
};

const es_visa_e2_cta = /** @type {(inputs: Visa_E2_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore sus opciones de visa E`)
};

/**
* | output |
* | --- |
* | "Explore your E visa options" |
*
* @param {Visa_E2_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_cta = /** @type {((inputs?: Visa_E2_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_cta(inputs)
	if (locale === "es") return es_visa_e2_cta(inputs)
	return en_visa_e2_cta(inputs)
});